module.exports = __webpack_public_path__ + "media/img/marquee/marquee-unsplash-01-beb2e7df918df66878a40f7b4fb16ba1.jpg";